
import { render } from 'react-dom'
import { memo, useCallback, useState, useEffect } from 'react'
import SubTwo from './SubTwo/SubTwo'
import SubOne from './SubOne/SubOne'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import srtParser2 from "srt-parser-2";
import SubsModal from "./SubsModal"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CompareSubs() {
	const [openModalSubs, setOpenModalSubs] = useState(false);
	const [subOneItems, setSubOneItems] = useState([])
	const [subTwoItems, setSubTwoItems] = useState([])
	const [subTwoName, setSubTwoName] = useState("umlang")

	const hanldeModalSubsOpen = (state) => {
		setOpenModalSubs(state)
	}
	// var parser = new srtParser2();
	// var srt_array = parser.fromSrt(srt);
	// console.log(srt_array);
	const parsSubtitle = (number, file) => {
		const reader = new FileReader();
		reader.readAsText(file);
		reader.onload = () => {
			const text = reader.result;
			let parser = new srtParser2();
			let result = parser.fromSrt(text);
			if (number == "one") setSubOneItems(result)
			if (number == "two") setSubTwoItems(result)
		}
	}

	function downloadFile(filename, text) {
		let element = document.createElement('a');
		element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent('\uFEFF' + text));
		element.setAttribute('download', filename);
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	const exportNewSubTwo = (newSubTwo) => {
		if (subOneItems.length !== newSubTwo.length) {
			toast.error("تعداد زیرنویس های اول و دوم با هم برابر نمی باشد", {
				position: "top-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
			});
			// toast("تعداد زیرنویس های اول و دوم با هم برابر نمی باشد")
		} else {
			let syncTimeSubs = newSubTwo.map((element, idx) => {
				element["startSeconds"] = subOneItems[idx]["startSeconds"]
				element["startTime"] = subOneItems[idx]["startTime"]
				element["endSeconds"] = subOneItems[idx]["endSeconds"]
				element["endTime"] = subOneItems[idx]["endTime"]
				element["id"] = subOneItems[idx]["id"]
				return element
			});
			let parser = new srtParser2();
			let subTwoSrt = parser.toSrt(syncTimeSubs)
			downloadFile(subTwoName, subTwoSrt);
		}
	}

	return (
		<div style={{ backgroundColor: "#191919" }}>
			<SubsModal subOneItems={subOneItems} subTwoItems={subTwoItems} openModalSubs={openModalSubs} hanldeModalSubsOpen={hanldeModalSubsOpen} />
			{/* <button onClick={()=>{hanldeModalSubsOpen(true)}}>متن زیرنویس ها</button> */}
			<div style={{ display: "flex" }}>
				<div style={{ width: "50%" }}>
					<span style={{ color: "white" }}>زیرنویس اول:</span>
					<input onChange={(event) => { if (event.target.files[0]) parsSubtitle("one", event.target.files[0]) }}
						style={{ backgroundColor: "#f7deb0" }}
						type='file' />
				</div>
				<div style={{ width: "50%" }}>
					<span style={{ color: "white" }}>زیرنویس دوم:</span>
					<input onChange={(event) => {
						if (event.target.files[0]) {
							parsSubtitle("two", event.target.files[0])
							setSubTwoName(event.target.files[0].name)
						}
					}}
						style={{ backgroundColor: "#f7deb0" }}
						type='file' />
				</div>
			</div>
			<div style={{ display: "flex" }}>
				<DndProvider backend={HTML5Backend}>
					<SubOne hanldeModalSubsOpen={hanldeModalSubsOpen} subOneItems={subOneItems} />
				</DndProvider>
				<DndProvider backend={HTML5Backend}>
					<SubTwo exportNewSubTwo={exportNewSubTwo} subTwoItems={subTwoItems} />
				</DndProvider>
			</div>
			<ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="colored"
			/>
		</div>

	)
}

export default CompareSubs
